import styled from 'styled-components';

export const StyledClearSearch = styled.i`
  display: none;
  font-size: 1.5em;
  :hover {
    text-shadow: 0 1px 1px rgba(80, 80, 80, 0.5);
  }
  :active {
    text-shadow: none;
  }
`;

export const StyledHR = styled.hr`
  &&& {
    margin-top: 5px;
  }
`;

export const StyledBrokerageTileContainer = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const StyledBrokerageFilter = styled.form`
  display: inline-block;
  position: absolute;
  right: 0;
  top: 0;
  padding: 1em;
  height: 100%;
  > input {
    height: 100%;
    font-size: 1.5rem;
    border: none;
    opacity: 0.5;
    border-bottom: 1.5px solid rgba(128, 128, 128, 0.6);
    width: 20vw;
    transition: all 0.5s;
    &::placeholder {
      opacity: 0.5;
    }
    &:focus {
      border: none;
      outline: none;
      opacity: 1;
    }
  }
`;
